<template>
  <ODialog ref="dialog" :max-width="1000">
    <v-card>
      <ODialogBar @close="dismiss">
        Timestamp: {{ strTimestamp }}
        <v-spacer />
        Recebido em: {{ strCreatedAt }}
        <v-spacer />
      </ODialogBar>

      <MediaVideo
        :rounded="false"
        v-if="media.type == 'video'"
        :key="media.uid"
        :media="media"
        :bus="bus"
      >
        <template v-slot:top-right>
          <MediaCaptionBox :number="media.channel" :color="media.source" />
        </template>
      </MediaVideo>

      <MediaImage
        v-if="media.type == 'image'"
        :key="media.uid"
        :media="media"
      />

      <v-card-text class="pa-6">
        <v-progress-circular v-if="isDownloading" indeterminate :size="36" />
        <v-btn v-else @click="doDownload">
          Download
          <v-icon @click="doDownload">mdi-download</v-icon>
        </v-btn>
        <pre>{{ JSON.stringify(media, null, ' ') }}</pre>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import MediaVideo from 'oderon-vue/cpts/media/MediaVideo.vue'
import MediaImage from 'oderon-vue/cpts/media/MediaImage.vue'
import MediaCaptionBox from 'oderon-vue/cpts/media/MediaCaptionBox.vue'
import moment from 'moment'
import Vue from 'vue'
import go from 'oderon-vue/models/go.js'
import { saveBlobAs } from 'oderon-vue/utils.js'

const bus = new Vue()

export default {
  components: { MediaImage, MediaVideo, MediaCaptionBox },
  data() {
    return {
      media: {},
      bus,
      isDownloading: false
    }
  },
  computed: {
    strTimestamp() {
      if (this.media == null || this.media.timestamp == null) return '─'
      return moment(this.media.timestamp).format('DD/MM/YYYY HH:mm:ss')
    },
    strCreatedAt() {
      if (this.media == null || this.media.createdAt == null) return '─'
      return moment(this.media.createdAt).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  methods: {
    open(media) {
      this.media = media
      return this.$refs.dialog.$open()
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    },

    async doDownload() {
      try {
        this.isDownloading = true
        let blob = await go('get', this.media.url, null, { asBlob: true })
        let filename = this.media.s3key.replaceAll('/', '-')
        saveBlobAs(blob, filename)
      } finally {
        this.isDownloading = false
      }
    }
  }
}
</script>

<style></style>
